import { render, staticRenderFns } from "./Cti.vue?vue&type=template&id=3a38455a&scoped=true&"
import script from "./Cti.vue?vue&type=script&lang=js&"
export * from "./Cti.vue?vue&type=script&lang=js&"
import style0 from "./Cti.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Cti.vue?vue&type=style&index=1&id=3a38455a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38455a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a38455a')) {
      api.createRecord('3a38455a', component.options)
    } else {
      api.reload('3a38455a', component.options)
    }
    module.hot.accept("./Cti.vue?vue&type=template&id=3a38455a&scoped=true&", function () {
      api.rerender('3a38455a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Cti.vue"
export default component.exports